"use client";

import "./SplashNotificationComponent.scss";

import { useRouter } from "next/navigation";

import { useTranslation } from "@/app/i18n/client";
import { useSplashNotificationStore } from "@/libs/store/SplashNotificationStore/SplashNotificationStore";
import { convertToKebabCase } from "@/utils/common/convertHelper/convertToKebabCase";

type SplashNotificationComponentProps = {
  useStyle?: string;
};

const SplashNotificationComponent = ({
  useStyle,
}: SplashNotificationComponentProps) => {
  const { giveValue, setRevertValue } = useSplashNotificationStore();
  const { t } = useTranslation("favourite");
  const router = useRouter();

  const handleRouteToFavourite = () => {
    router.push("/account/favorites");
  };

  const handleClickRemoveFavourite = () => {
    setRevertValue({
      idProduct: giveValue.idProduct,
      typeOfProduct: giveValue.typeOfProduct,
      typeAlert: giveValue.typeAlert,
      showSplashNotification: giveValue.showSplashNotification,
    });
  };

  return (
    <div id={convertToKebabCase("SplashNotificationComponent")}>
      {giveValue.showSplashNotification && (
        <div className="SnackBar">
          <div className="inline-flex min-h-14 w-[340px] items-center justify-start gap-2 rounded-lg bg-[#DCF7E4] px-4 py-3 md:h-14 md:w-fit md:min-w-[22.5rem] md:rounded-none">
            <div className="inline-flex items-center justify-start gap-2">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.0005 22C6.48633 22 2 17.5142 2 12C2 6.48584 6.48584 2 12 2C17.5142 2 22 6.48584 22 12C22 17.5142 17.5142 22 12.0005 22ZM12.0005 3C7.03759 3 3 7.0376 3 12C3 16.9624 7.0376 21 12 21C16.9624 21 21 16.9624 21 12C21 7.0376 16.9629 3 12.0005 3Z"
                  fill="#459947"
                />
                <path
                  d="M9.82589 15.9998H9.81678C9.66787 15.9971 9.52646 15.9345 9.42469 15.8252L6.89698 13.1148C6.69021 12.8936 6.70253 12.5465 6.92429 12.3398C7.14551 12.1335 7.49262 12.1448 7.69937 12.3671L9.83874 14.6607L16.3131 8.16118C16.5274 7.94746 16.8755 7.94531 17.0887 8.15904C17.3035 8.37276 17.3046 8.7204 17.0909 8.93465L10.2148 15.8381C10.1114 15.942 9.97158 15.9998 9.82589 15.9998Z"
                  fill="#459947"
                />
              </svg>

              <p className="shrink text-base font-normal leading-normal text-text-base">
                {`${
                  giveValue.typeAlert === "add"
                    ? t("alertAddFavourite")
                    : t("alertRemoveFavourite")
                }`}
              </p>
            </div>

            {giveValue.typeAlert === "remove" ? (
              <button
                type="button"
                className="text-red-500"
                onClick={handleClickRemoveFavourite}
              >
                {t("cancel")}
              </button>
            ) : null}
            {giveValue.typeAlert === "add" ? (
              <button
                type="button"
                className="text-red-500"
                onClick={handleRouteToFavourite}
              >
                {t("seeListFavourite")}
              </button>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};

export default SplashNotificationComponent;
